import { Button, Checkbox, Col, Input, Row, Tooltip } from 'antd';
import { Loader } from 'components/Global';
import Ellipse from 'components/Global/Ellipse';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import './index.scss';
import { DeductionsModalProps } from './type';

const MasterDeductionModal: React.FC<DeductionsModalProps> = ({
	onDataChange,
	isLoading,
	activeTab,
	isUSD,
	data,
	setData,
	fetchMasterDeductions,
}) => {
	const [deductionsData, setDeductionsData] = useState<any>();
	const [showAll, setShowAll] = useState<boolean>(false);

	const updateData = (newData: any) => {
		setDeductionsData(newData);
		onDataChange(newData);
	};

	const handleChange = (index: string, value: string | boolean) => {
		let newData = [];
		if (typeof value === 'boolean') {
			newData = data.map((item: any) => {
				if (item.id === index) {
					return { ...item, isChecked: value, isUserChecked: value };
				}
				return item;
			});
		} else {
			newData = data.map((item: any) => {
				if (item.id === index) {
					return {
						...item,
						isChanged: true,
						amount: isNaN(parseFloat(value))
							? parseFloat('0.00')
							: value,
					};
				}
				return item;
			});
		}
		setData(newData);
		updateData(newData);
	};

	const toggleCurrency = (index: string, currentCurrency: string) => {
		const nextCurrency = currentCurrency === 'ZMW' ? 'USD' : 'ZMW';
		const newData = data.map((item: any) => {
			if (item.id === index) {
				return { ...item, isChanged: true, currency: nextCurrency };
			}
			return item;
		});
		setData(newData);
		updateData(newData);
	};

	const handleBlur = (index: number) => {
		const newData = data.map((item: any) => {
			if (item.id === index) {
				return {
					...item,
					amount:
						isNaN(item.amount) || item.amount < 0
							? '0.00'
							: parseFloat(item.amount).toFixed(2),
				};
			}
			return item;
		});
		setData(newData);
		updateData(newData);
	};

	useEffect(() => {
		onDataChange(data);
	}, [data]);

	useEffect(() => {
		if (activeTab === 'deductions') {
			fetchMasterDeductions();
		}
	}, [activeTab]);

	const renderItems = (items: any) =>
		items?.map((item: any, idx: number) => (
			<Col key={item.id} span={12}>
				<div key={item.id} className={styles.earningsFields}>
					<div className="checkbox">
						<Checkbox
							checked={item.isChecked}
							onChange={() =>
								handleChange(item?.id, !item.isChecked)
							}
						/>
					</div>
					<label className={styles.label}>
						<Ellipse
							maxLength={20}
							message={item?.description}
							isTooltip={true}
							tooltipMessage={item?.description}
							key={item?.description}
						/>
					</label>
					<div className={styles.inputContainer}>
						<Input
							value={item?.amount ?? 0}
							onChange={(e) =>
								handleChange(item?.id, e.target.value)
							}
							onBlur={() => handleBlur(item?.id)}
							type="number"
							disabled={item.isDisabled}
							className={styles.input}
							addonAfter={
								isUSD && !item.isDisabled ? (
									<Tooltip
										title={`Switch to ${(item.currency || 'USD') === 'ZMW' ? 'USD' : 'ZMW'
											}`}
									>
										<span
											role="button"
											tabIndex={0}
											className={`${styles.currencyToggle} ${(item.currency || 'USD') === 'ZMW'
													? styles.currencyZmw
													: styles.currencyUsd
												}`}
											onClick={() =>
												toggleCurrency(item?.id, item.currency || 'USD')
											}
											onKeyDown={(e) => {
												if (e.key === 'Enter' || e.key === ' ') {
													e.preventDefault();
													toggleCurrency(item?.id, item.currency || 'USD');
												}
											}}
										>
											{item.currency || 'USD'}
										</span>
									</Tooltip>
								) : (
									<span className={styles.currencyStatic}>
										{isUSD ? item.currency || 'USD' : 'ZMW'}
									</span>
								)
							}
						/>
					</div>
				</div>
			</Col>
		));

	const toggleShowAll = () => {
		setShowAll(!showAll);
	};

	const topPriorityItems = deductionsData?.slice(0, 12) || [];
	const nonDefaultItems = showAll ? deductionsData?.slice(12) : [];

	useEffect(() => {
		setDeductionsData(data);
	}, [data]);

	return (
		<div className="deductionsFields">
			{isLoading ? (
				<div
					style={{
						display: 'flex',
						justifyContent: 'center',
						alignItems: 'center',
						height: '50vh',
					}}
				>
					<Loader />
				</div>
			) : (
				<div className={styles.deductionItems}>
					<Row gutter={12}>{renderItems(topPriorityItems)}</Row>
					<Row gutter={12} className="extra-deductions">
						{/* {!showAll && ( */}
						<hr
							className="color-purple"
							style={{
								width: '100vw',
								marginBottom: '20px',
							}}
						/>
						{/* )} */}
						{renderItems(nonDefaultItems)}
					</Row>
					<Row>
						<Col span={24}>
							<p style={{ float: 'right' }}>
								<Button
									style={{ border: 'none' }}
									className={styles.showMoreLink}
									onClick={toggleShowAll}
								>
									{showAll ? 'Show Less' : 'Show More'}
								</Button>
							</p>
						</Col>
					</Row>
				</div>
			)}
		</div>
	);
};

export default MasterDeductionModal;
